var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-holder"},[(_vm.template)?_c('renderer',{attrs:{"company_id":_vm.companyData.gds_owner_id,"contact_id":_vm.userData.id,"template":_vm.template},on:{"move_in":_vm.moveIn}}):_c('div',[_c('async-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }